import { IViewAccessibility } from './interfaces/view-accessibility.interface';

export class ViewAccessibility implements IViewAccessibility {
    id: number = null;
    viewId: number = null;
    userId: string = null;
    groupId: string = null;
    userName: string = null;
    groupName: string = null;
    viewName: string = null;
    isInherited: boolean;

    public static createCopy(viewAccessibility: IViewAccessibility): ViewAccessibility {
        const instance = new ViewAccessibility();
        instance.id = viewAccessibility.id;
        instance.viewId = viewAccessibility.viewId;
        instance.userId = viewAccessibility.userId;
        instance.groupId = viewAccessibility.groupId;
        instance.isInherited = viewAccessibility.isInherited;

        return instance;
    }
}
